import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';

import { termsRoutes, genericFallbackRoutes } from './routes';

export const AppRouter = () => {
  const getRoutesByDomain = () => {
    const parts = window.location.hostname.split('.');
    if (parts[0].includes(process.env.REACT_APP_TERMS_SUBDOMAIN as string)) {
      return termsRoutes;
    }
    return termsRoutes; // genericFallbackRoutes;
  };

  return (
    <BrowserRouter>
      <Routes>
        {
          [...getRoutesByDomain()].map(({ path, Component }) => (
            <Route
              key={path}
              path={path}
              element={<Component />}
            />
          ))
        }
        <Route path="/*" element={<Navigate to={genericFallbackRoutes[0].to} replace />} />
      </Routes>
    </BrowserRouter>
  );
};
